import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../constants/api';
import ContactLogo from '../components/shared/ContactLogo';

const ActivationPage = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [googleActivationMessage, setGoogleActivationMessage] = useState('');
  const [checkingAuth, setCheckingAuth] = useState(true);
  const navigate = useNavigate();

  // Check if user is authenticated
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }
    
    // Check for Google activation message
    const message = localStorage.getItem('google_activation_message');
    if (message) {
      setGoogleActivationMessage(message);
      localStorage.removeItem('google_activation_message');
    }
    
    setCheckingAuth(false);
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      
      // Step 1: Activate the account
      console.log('[Activation] Step 1: Activating account...');
      const activationResponse = await axios.post(
        `${API}/auth/activate`, 
        { code },
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      console.log('[Activation] Activation response:', activationResponse.data);
      
      // Step 2: Fetch updated user data from server
      console.log('[Activation] Step 2: Fetching updated user data...');
      const userResponse = await axios.get(`${API}/auth/me`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      console.log('[Activation] User data received:', userResponse.data);
      
      if (userResponse.data) {
        // Step 3: Update localStorage with fresh user data
        const userData = userResponse.data;
        console.log('[Activation] Step 3: Updating localStorage with max_profiles:', userData.max_profiles);
        localStorage.setItem('user', JSON.stringify(userData));
        
        // Verify the write was successful
        const verifyData = JSON.parse(localStorage.getItem('user'));
        console.log('[Activation] Verified localStorage max_profiles:', verifyData?.max_profiles);
      }
      
      // Step 4: Small delay to ensure localStorage is written, then redirect
      console.log('[Activation] Step 4: Redirecting to dashboard...');
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 100);
      
    } catch (error) {
      console.error('[Activation] Error:', error);
      setError(error.response?.data?.detail || 'Código de activación inválido');
      setLoading(false);
    }
  };

  if (checkingAuth) {
    return (
      <div className="min-h-screen bg-gradient-contact flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-300"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-contact flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <ContactLogo className="h-12 w-auto mx-auto" />
          <h2 className="mt-6 text-2xl font-bold text-black">
            Activar cuenta
          </h2>
          <p className="mt-2 text-gray-600">
            Ingresa el código de activación que recibiste con tu tarjeta NFC
          </p>
          {googleActivationMessage && (
            <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm text-blue-800 font-medium">
                    Activación requerida para cuenta de Google
                  </p>
                  <p className="text-sm text-blue-700 mt-1">
                    {googleActivationMessage}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 card-shadow-lg sm:rounded-xl sm:px-10 border border-gray-100">
          <form className="space-y-6" onSubmit={handleSubmit}>
            {error && (
              <div className="error-state">
                {error}
              </div>
            )}
            
            <div>
              <label htmlFor="code" className="form-label">
                Código de activación
              </label>
              <div className="mt-1">
                <input
                  id="code"
                  name="code"
                  type="text"
                  required
                  value={code}
                  onChange={(e) => setCode(e.target.value.toUpperCase())}
                  className="form-input text-center font-mono text-lg tracking-widest"
                  placeholder="XXXX-XXXX-XXXX"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="btn-primary w-full"
              >
                {loading ? 'Activando...' : 'Activar cuenta'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

// Sidebar Component

export default ActivationPage;
